import helpers from '../modules/helpers.js';

const dataLayerObj = {

    eventObj: {
        event: 'bx-form-send'
    },

    purchaseObj: {
        purchase: {
            transaction_id: "",
            value: 2184,
            currency: "CHF",
            items: [
                {
                    item_name: "sql",
                    price: 2184,
                },
            ]
        }
    },

    /* Create a new dataLayerObject depend on an event type */
    getDataLayerObject(dataLayerEvent, formData) {
        let object = {};

        // set event type
        Object.assign(object, this.getDataLayerEventType(dataLayerEvent));

        // Loop through fields depends on an event type and creates a new object
        for(const field in object.fields) {
            if(field in formData) {
                // Merge phone_prefix and phone_number.
                if(field === 'phone_number') {
                    Object.assign(object, {[object.fields[field]]: helpers.mergePhonePrefixAndPhoneNumber(formData['phone_prefix'], formData[[field]]) });
                } else {
                    Object.assign(object, {[object.fields[field]]: formData[[field]]});
                }
            }
        }

        // delete "fields" key from object
        delete object.fields;

        // return dataLayer object
        return object;
    },

    /* Get an event type */
    getDataLayerEventType(dataLayerEvent) {
        switch(dataLayerEvent) {
            case 'mql':
                return {
                    event: dataLayerEvent,
                    fields: {
                        firstname: 'user_profile_firstname',
                        lastname: 'user_profile_lastname',
                        email: 'user_profile_email',
                        phone_number: 'user_profile_phone_number',
                    }
                }
        }
    },

    /**
     * Find an object in collection
     * console.info(findObjByItemName(obj.purchase.items, 'sql'));
     *
     * Console Command
     * dataLayer[xx].purchase.items.find(x => x.item_name === 'sql')
     *
     * */
    findObjByItemName(arr, searchValue) {
        return arr.find(x => x.item_name === searchValue)
    },

    setFormEvent(data) {

        if (data.hasOwnProperty('data') && data.data.hasOwnProperty('item_name') && data.data.item_name === "sql") {
            // Set transaction_id
            if (data.data.hasOwnProperty('transaction_id')) {
                dataLayerObj.purchaseObj['purchase']['transaction_id'] = data.data.transaction_id;
            }

            return {...this.eventObj, ...this.purchaseObj};
        } else {
            window.dataLayer.push(this.eventObj);
        }
    }
};

export default dataLayerObj;
